import React, { useMemo } from "react";
import styles from "./Sidebar.module.css";
import { NavLink, useLocation } from "react-router-dom";

import { useUsers } from "../Commoncontext/UsersContext";
import { useSelectedCompany } from "../Commoncontext/SelectedCompanyContext";
import { useCompanyConfig } from "../Commoncontext/CompanyConfigContext";
import { getVisibleNavigationItems } from "../Utils/navigationUtils";

/* 🔹 Icon-mäppäys */
import IconHome from "../Images/IconHome";
import IconScreen from "../Images/IconScreen";
import IconSauna from "../Images/IconSauna";
import IconReporting from "../Images/IconReporting";
import IconSettings from "../Images/IconSettings";
import IconAnnouncements from "../Images/IconAnnouncements";
import IconServicerequests from "../Images/IconServicerequests";
import IconWizard from "../Images/IconWizard";
import IconDocuments from "../Images/IconDocuments";

const ICONS = {
  home: IconHome,
  screen: IconScreen,
  sauna: IconSauna,
  reporting: IconReporting,
  settings: IconSettings,
  announcements: IconAnnouncements,
  servicerequests: IconServicerequests,
  chatbot: IconWizard,
  documents: IconDocuments,
};

function Sidebar() {
  const { user } = useUsers();
  const { selectedCompanyId } = useSelectedCompany();
  const { enabledItems, loading } = useCompanyConfig();
  const location = useLocation();

  const visibleItems = useMemo(() => {
    return getVisibleNavigationItems({
      enabledItems,
      user,
      selectedCompanyId,
    });
  }, [enabledItems, user, selectedCompanyId]);

  if (!user || !user.suostumus) {
    return <div className={styles.sidebar} />;
  }

  return (
    <div className={styles.sidebar}>
      <nav className={styles.nav}>
        {loading && <div className={styles.loading}>Ladataan…</div>}

        {visibleItems.map((item) => {
          const Icon = ICONS[item.icon] || null;

          const isSettings =
            item.route === "/settings" &&
            location.pathname.startsWith("/settings");

          return (
            <NavLink
              key={item.key}
              to={item.route}
              end={!isSettings}
              className={({ isActive }) =>
                [
                  styles.sidebarItem,
                  isActive || isSettings ? styles.active : "",
                ].join(" ")
              }
            >
              <span className={styles.activeBar} aria-hidden="true" />
              <span className={styles.iconWrap}>
                {Icon && <Icon />}
              </span>
              <span className={styles.linkText}>{item.label}</span>
            </NavLink>
          );
        })}

        <div className={styles.brandFooter}>
          <img
            src="/logooranssi.png"
            alt="AsukasHuudi logo"
            className={styles.brandLogo}
          />
          <span className={styles.brandText}>AsukasHuudi</span>
        </div>
      </nav>
    </div>
  );
}

export default Sidebar;